export default __webpack_public_path__ + "static/media/aditya.62a51bf6.jpeg";